import { RouterProvider, createHashRouter, createRoutesFromElements, Route } from "react-router-dom";
import { LayoutWithSidebar } from "./components/shared/layouts/LayoutWithSidebar";
import { LayoutWithHeader } from "./components/shared/layouts/LayoutWithHeader";
import { AuthProvider } from "./contexts/AuthContext";
import { getSidebarItems, PublicRoutes, SidebarPrivateRoutes, ErrorRoutes } from "./routes";
import { ToastContainerWrapper } from "./components/shared/toast/Toast";
import { useAuth } from "./contexts/AuthContext";
import "./App.css";

const App = () => {
  return (
    <AuthProvider>
      <ToastContainerWrapper />
      <AuthConsumer />
    </AuthProvider>
  );
};

const AuthConsumer = () => {
  const { user } = useAuth();
  const sidebarItems = getSidebarItems(user?.codope);

  const router = createHashRouter(
    createRoutesFromElements(
      <>
        <Route element={<LayoutWithHeader />}>
          {PublicRoutes}
        </Route>

        <Route element={<LayoutWithSidebar sidebarItems={sidebarItems} />}>
          {SidebarPrivateRoutes}
        </Route>

        {ErrorRoutes}
      </>
    )
  );

  return <RouterProvider router={router} />;
};

export default App;
